import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { NgIf } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabelModule } from 'primeng/floatlabel';
import { FormsModule } from '@angular/forms';
import { IPhone } from '../../../models/phone';

@Component({
  selector: 'lib-phone-number-editor',
  standalone: true,
  imports: [DialogModule, ButtonModule, InputTextModule, FloatLabelModule, NgIf, FormsModule],
  templateUrl: './phone-number-editor.component.html',
})
export class PhoneNumberEditorComponent implements OnChanges
{
  @Input() visible = false;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() phone?: IPhone;
  @Output() save: EventEmitter<IPhone> = new EventEmitter<IPhone>();
  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();

  workingPhone: IPhone = { id: 0, phoneNumber: '', e164PhoneNumber: '', phoneType:0, smsCapable: false };

  ngOnChanges(changes: SimpleChanges)
  {
    if (changes['phone'] || (changes['visible'] && this.visible))
    {
      if (this.phone)
      {
        this.workingPhone = { ...this.phone };
      }
      else
      {
        this.workingPhone = { ...this.workingPhone, id: 0, phoneNumber: '', e164PhoneNumber: '' };
      }
    }
  }

  close()
  {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }

  onSave()
  {
    this.save.emit({ ...this.workingPhone });
    this.close();
  }

  onCancel()
  {
    this.cancel.emit();
    this.close();
  }
}
